var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-faq__accordion--wrapper" }, [
    _c(
      "div",
      { staticClass: "c-faq__accordion--inner" },
      _vm._l(_vm.category.items, function(item, index) {
        return _c("v-faq-accordion-item", {
          key: item.id,
          attrs: {
            item: item,
            category: _vm.category.faqCategory,
            isDefaultQuestion: _vm.isDefaultQuestion(item)
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }